import { BridgeAppraisalStatus } from '../../../../../../common/constants/BridgeAppraisalStatus';

export class BridgeAppraisalStatusGroupMapper {
    /**
     * Enum-like grouping sections.
     * Centralized numeric ordering + identity.
     */
    static Section = {
        PendingKeyItems: 0,
        BfiToOrder: 1,
        Ordered: 2,
        Appraised: 3,
        ApprovedWaitingToClose: 4,
        Closed: 5,
    } as const;

    /**
     * Centralized labels tied directly to the Section enum.
     */
    static Labels: Record<number, string> = {
        [this.Section.PendingKeyItems]: 'NOT APPRAISED (Pending Key Items)',
        [this.Section.BfiToOrder]: 'BFI TO ORDER (Key Items Satisfactory)',
        [this.Section.Ordered]: 'ORDERED',
        [this.Section.Appraised]: 'APPRAISED (received and review complete)',
        [this.Section.ApprovedWaitingToClose]: 'APPROVED / WAITING TO CLOSE',
        [this.Section.Closed]: 'CLOSED',
    };

    /**
     * Returns the numeric group key used for sorting and grouping.
     * Values 0–3 collapse into bucket 0.
     */
    static getGroupSection(status: BridgeAppraisalStatus): number | undefined {
        const preAppraisalStatuses = [
            BridgeAppraisalStatus.NothingReceived,
            BridgeAppraisalStatus.PaymentReceived,
            BridgeAppraisalStatus.SurveyReceived,
            BridgeAppraisalStatus.PaymentAndSurveyReceived,
        ];

        if (preAppraisalStatuses.includes(status)) {
            return this.Section.PendingKeyItems;
        }

        switch (status) {
            case BridgeAppraisalStatus.ReadyForAppraisal:
                return this.Section.BfiToOrder;
            case BridgeAppraisalStatus.AppraisalOrdered:
                return this.Section.Ordered;
            case BridgeAppraisalStatus.Appraised:
                return this.Section.Appraised;
            case BridgeAppraisalStatus.ApprovedAndWaitingToClose:
                return this.Section.ApprovedWaitingToClose;
            case BridgeAppraisalStatus.Closed:
                return this.Section.Closed;
            default:
                return undefined;
        }
    }

    /**
     * Returns the display label for a given group key.
     * Safe for undefined.
     */
    static getGroupLabel(section: number | undefined): string {
        if (section === undefined) return '';
        return this.Labels[section] ?? '';
    }

    /**
     * Convenience method: raw enum → final display label.
     */
    static getLabelFromStatus(status: BridgeAppraisalStatus): string {
        return this.getGroupLabel(this.getGroupSection(status));
    }
}
